"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
require("antd/lib/button/style");
var _button = _interopRequireDefault(require("antd/lib/button"));
require("antd/lib/input-number/style");
var _inputNumber = _interopRequireDefault(require("antd/lib/input-number"));
require("antd/lib/form/style");
var _form = _interopRequireDefault(require("antd/lib/form"));
var _lodash = require("lodash");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _ = require("../..");
var _utils = require("../../../utils");
require("./AddSessionForm.less");
var _SelectInput = require("../../../components/SelectInput");
var _Tooltip = require("../../../components/Tooltip");
var _util = require("../util");
var _api = require("../api");
var _async = _interopRequireDefault(require("react-select/async"));
var _constants = require("../constants");
var _DropdownIndicator = require("../../SearchableReactSelect/components/DropdownIndicator");
var _TextInput = require("../../../components/TextInput");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var NO_MODERATOR = 'no-moderator';
var updateEndDate = function updateEndDate(startDate, form) {
  if (startDate) {
    // onChange passes date before getValueFromEvent is called
    // thus, date must be rounded here as well
    var newDate = (0, _momentTimezone.default)(roundSelectedTime(startDate)).clone().add(1, 'hours');
    form.setFieldsValue({
      endAt: newDate
    });
  } else {
    form.setFieldsValue({
      endAt: null
    });
  }
};
var roundSelectedTime = function roundSelectedTime(date) {
  if (!date) {
    return null;
  }
  var currentTime = (0, _momentTimezone.default)(date);
  var remainder = 15 - currentTime.minute() % 15;
  if (remainder !== 15) {
    currentTime.add(remainder, 'minutes');
  }
  return currentTime;
};
var useFormValidators = function useFormValidators(_ref) {
  var form = _ref.form,
    onCancel = _ref.onCancel,
    onSubmit = _ref.onSubmit,
    isEditForm = _ref.isEditForm;
  var isFieldsTouched = form.isFieldsTouched,
    validateFieldsAndScroll = form.validateFieldsAndScroll;
  var handleSubmit = (0, _react.useCallback)(function (e) {
    e.preventDefault();
    if (isEditForm && !isFieldsTouched()) {
      onCancel();
      return;
    }
    validateFieldsAndScroll(function (err, values) {
      if (err) {
        return;
      }
      var clinicianModerators = values.clinicianModerators,
        patientModerators = values.patientModerators;
      var clinicianModeratorIds = clinicianModerators === null || clinicianModerators === void 0 ? void 0 : clinicianModerators.map(function (m) {
        return m.value;
      });
      var patientModeratorIds = patientModerators === null || patientModerators === void 0 ? void 0 : patientModerators.map(function (m) {
        return m.value;
      });
      var moderatorRateValue = values.moderatorRate ? (0, _utils.parsePriceFormStringToNum)(values.moderatorRate) : 0;
      var payload = {
        startAt: (0, _momentTimezone.default)(values.startAt).startOf('minute').utc().format(),
        endAt: (0, _momentTimezone.default)(values.endAt).startOf('minute').utc().format(),
        repeatWeeks: values.repeatWeeks,
        capacity: values.capacity,
        moderatorId: values.moderatorId === NO_MODERATOR ? null : values.moderatorId,
        moderatorRate: moderatorRateValue,
        clinicianModeratorIds: clinicianModeratorIds,
        patientModeratorIds: patientModeratorIds
      };
      onSubmit(payload);
    });
  }, [onSubmit, validateFieldsAndScroll]);
  var fieldsError = form.getFieldsError();
  var validationErrors = (0, _react.useMemo)(function () {
    return (0, _lodash.chain)(fieldsError).values().compact().some(function (e) {
      return e;
    }).value();
  }, [fieldsError]);
  var endDateValidator = (0, _react.useMemo)(function () {
    var message = 'End date should be after start date';
    return (0, _lodash.debounce)(function (rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      var startDate = form.getFieldValue('startAt');
      if (!startDate) {
        callback();
        return;
      }
      callback(startDate.isBefore(value) ? undefined : message);
    });
  }, []);
  return {
    endDateValidator: endDateValidator,
    handleSubmit: handleSubmit,
    validationErrors: validationErrors
  };
};
var getMoment = function getMoment(date) {
  return date && (0, _momentTimezone.default)(date);
};
var AddSessionForm = function AddSessionForm(_ref2) {
  var form = _ref2.form,
    onCancel = _ref2.onCancel,
    moderators = _ref2.moderators,
    onSubmit = _ref2.onSubmit,
    session = _ref2.session,
    group = _ref2.group,
    processing = _ref2.processing,
    defaultCapacity = _ref2.defaultCapacity;
  var getFieldDecorator = form.getFieldDecorator,
    getFieldValue = form.getFieldValue;
  var isWebinarGroup = !!group.isWebinar;
  var moderatorId = getFieldValue('moderatorId');
  var _getCurrentGroupSessi = (0, _util.getCurrentGroupSessionModerators)(group, session),
    patientModerators = _getCurrentGroupSessi.patientModerators,
    clinicianModerators = _getCurrentGroupSessi.clinicianModerators;
  var _getReactSelectClinic = (0, _util.getReactSelectClinicianAndPatientModerators)({
      clinicianModerators: clinicianModerators,
      patientModerators: patientModerators
    }),
    clinicianModeratorOptions = _getReactSelectClinic.clinicianModeratorOptions,
    patientModeratorOptions = _getReactSelectClinic.patientModeratorOptions;
  var _useClinicianAndPatie = (0, _api.useClinicianAndPatientModeratorsSearch)(form, moderatorId),
    onLoadClinicianOptions = _useClinicianAndPatie.onLoadClinicianOptions,
    onLoadPatientOptions = _useClinicianAndPatie.onLoadPatientOptions;
  var _useFormValidators = useFormValidators({
      form: form,
      onCancel: onCancel,
      onSubmit: onSubmit,
      isEditForm: !!session
    }),
    endDateValidator = _useFormValidators.endDateValidator,
    handleSubmit = _useFormValidators.handleSubmit,
    validationErrors = _useFormValidators.validationErrors;
  var filterModeratorOptions = function filterModeratorOptions(option) {
    return option ? option.data.value !== moderatorId : false;
  };
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: processing,
    size: "large"
  }, /*#__PURE__*/_react.default.createElement(_form.default, {
    onSubmit: handleSubmit,
    className: "AddSessionForm",
    size: "large",
    hideRequiredMark: true
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Start Date"
  }, getFieldDecorator('startAt', {
    initialValue: getMoment(session === null || session === void 0 ? void 0 : session.startAt),
    first: true,
    getValueFromEvent: roundSelectedTime,
    rules: [{
      required: true,
      message: 'Please enter start date'
    }]
  })( /*#__PURE__*/_react.default.createElement(_.DatePicker, {
    format: "MM/DD/YYYY h:mm A",
    placeholder: "Enter start date",
    showTime: {
      format: 'h:mm A'
    },
    showToday: false,
    size: "large",
    onChange: function onChange(date) {
      return updateEndDate(date, form);
    }
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "End Date"
  }, getFieldDecorator('endAt', {
    initialValue: getMoment(session === null || session === void 0 ? void 0 : session.endAt),
    first: true,
    rules: [{
      required: true,
      message: 'Please enter end date'
    }, {
      validator: endDateValidator
    }]
  })( /*#__PURE__*/_react.default.createElement(_.DatePicker, {
    format: "MM/DD/YYYY h:mm A",
    placeholder: "Enter end date",
    showTime: {
      format: 'h:mm A'
    },
    showToday: false,
    size: "large"
  }))), !session && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    placement: "left",
    title: "Total number of weekly sessions to add. Limit of 12 sessions at a time."
  }, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Number of sessions"
  }, getFieldDecorator('repeatWeeks', {
    initialValue: 1,
    first: true,
    rules: [{
      required: true,
      message: 'Need to have at least 1 session to add'
    }]
  })( /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    min: 1,
    max: 12
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "RSVP Capacity"
  }, getFieldDecorator('capacity', {
    first: true,
    initialValue: (session === null || session === void 0 ? void 0 : session.capacity) || defaultCapacity,
    rules: [{
      required: true,
      message: 'Please enter the session’s rsvp capacity'
    }]
  })( /*#__PURE__*/_react.default.createElement(_inputNumber.default, {
    min: 1,
    max: _utils.MAX_DAILYCO_GROUP_SESSION_CAPACITY
  }))), session && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Session Moderator"
  }, getFieldDecorator('moderatorId', {
    initialValue: session.moderatorId
  })( /*#__PURE__*/_react.default.createElement(_SelectInput.SelectInput, {
    id: "Moderator Change Dropdown",
    form: form
  }, /*#__PURE__*/_react.default.createElement(_SelectInput.SelectInput.Option, {
    value: NO_MODERATOR
  }, "No Moderator"), moderators.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(_SelectInput.SelectInput.Option, {
      label: option.firstName,
      key: option.id,
      value: option.id
    }, (0, _utils.personName)(option));
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Moderator Rate"
  }, /*#__PURE__*/_react.default.createElement("div", null, "(auto-populated from clinician group session rate, after the session ends)"), getFieldDecorator('moderatorRate', {
    initialValue: (0, _utils.parsePriceNumToFormString)(session.moderatorRate),
    rules: [{
      validator: (0, _utils.priceValidator)()
    }]
  })( /*#__PURE__*/_react.default.createElement(_TextInput.TextInput, {
    placeholder: "0.00",
    size: "large"
  })))), isWebinarGroup && session && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more clinician moderators"
  }, getFieldDecorator(_constants.CLINICIAN_MODERATORS_FIELD_NAME, {
    initialValue: clinicianModeratorOptions,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search clinician moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadClinicianOptions,
    isClearable: false,
    isMulti: true
  }))), /*#__PURE__*/_react.default.createElement(_form.default.Item, {
    label: "Select more patient moderators"
  }, getFieldDecorator(_constants.PATIENT_MODERATORS_FIELD_NAME, {
    initialValue: patientModeratorOptions,
    rules: [{
      required: false
    }]
  })( /*#__PURE__*/_react.default.createElement(_async.default, {
    className: "searchable-react-select mb-[24px] mt-0",
    classNamePrefix: "searchable-select-inner",
    placeholder: "Search patient moderators...",
    components: {
      IndicatorSeparator: function IndicatorSeparator() {
        return null;
      },
      DropdownIndicator: _DropdownIndicator.DropdownIndicator
    },
    filterOption: filterModeratorOptions,
    loadOptions: onLoadPatientOptions,
    isClearable: false,
    isMulti: true
  })))), /*#__PURE__*/_react.default.createElement(_form.default.Item, null, /*#__PURE__*/_react.default.createElement(_button.default, {
    type: "primary",
    htmlType: "submit",
    size: "large",
    block: true,
    disabled: validationErrors,
    loading: processing
  }, session ? 'Update' : 'Create', " session"))));
};
AddSessionForm.propTypes = {
  onCancel: _propTypes.default.func,
  onSubmit: _propTypes.default.func,
  processing: _propTypes.default.bool,
  session: _propTypes.default.object,
  group: _propTypes.default.object
};
var _default = _form.default.create({
  name: 'AddSession'
})(AddSessionForm);
exports.default = _default;